/**
 * page action constants used by reducers
 */
export const ADD_COMPONENT_TO_PAGE = 'page/ADD_COMPONENT_TO_PAGE';
export const CHANGE_PAGE_PROPERTY = 'page/CHANGE_PAGE_PROPERTY';
export const CREATE_UNSAVED_PAGE = 'page/CREATE_UNSAVED_PAGE';
export const DUPLICATE_PAGE = 'page/DUPLICATE_PAGE';
export const EDIT_COMPONENT_ON_THE_PAGE = 'page/EDIT_COMPONENT_ON_THE_PAGE';
export const GET_PAGE_FAILURE = 'page/GET_PAGE_FAILURE';
export const GET_PAGE_REQUEST = 'page/GET_PAGE_REQUEST';
export const GET_PAGE_SUCCESS = 'page/GET_PAGE_SUCCESS';
export const PAGE_COMPONENTS_LIST_CHANGED = 'page/PAGE_COMPONENTS_LIST_CHANGED';
export const SAVE_PAGE_SUCCESS = 'page/SAVE_PAGE_SUCCESS';
export const SAVE_PAGE_FAILURE = 'page/SAVE_PAGE_FAILURE';
export const REMOVE_ACTIVE_PAGE = 'page/REMOVE_ACTIVE_PAGE';
export const REMOVE_COMPONENT_FROM_PAGE = 'page/REMOVE_COMPONENT_FROM_PAGE';
export const REPLACE_COMPONENT_ON_THE_PAGE = 'page/REPLACE_COMPONENT_ON_THE_PAGE';
export const DELETE_PAGE_REQUESTED = 'page/DELETE_PAGE_REQUESTED';
export const DELETE_PAGE_REJECTED = 'page/DELETE_PAGE_REJECTED';
